const DropDownMenu: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return <div className="dropdown-menu-container">{children}</div>;
};

export default DropDownMenu;
